import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';

const PermissionsPicker = ({ availablePermissions, selectedPermissions, onChange, isFirstUser = null }) => {
    const handleTogglePermission = p => {
        if (selectedPermissions.find(({ id }) => id === p.id)) {
            onChange([...selectedPermissions.filter(({ id }) => id !== p.id)]);
        }
        else {
            onChange([...selectedPermissions, p]);
        }
    };

    return (
        <Grid sx={{ p: 2 }} container>
            {availablePermissions.map(({ id, label, name, description }) => (
                <Grid size={{ xs: 6 }} key={id}>
                    <ListItem
                        key={id}
                        dense
                        disableGutters
                        disablePadding
                    >
                        <ListItemButton
                            onClick={() => {
                                if (!(name === 'Manage Users' && isFirstUser)) {
                                    handleTogglePermission({ id });
                                }
                            }}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    disableRipple
                                    checked={Boolean(selectedPermissions.find(p => p.id === id))}
                                    disabled={name === 'Manage Users' && isFirstUser}
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={label}
                                secondary={description}
                            />
                        </ListItemButton>
                    </ListItem>
                </Grid>
            ))}
        </Grid>
    );
};

export default PermissionsPicker;
